module.exports = __webpack_public_path__ + "static/media/plus-blue.a83b310e.svg";